// vim: ft=javascriptreact
import { useState } from 'react'
import useBookings from '../hooks/useBooking'
import { isFuture, parseISO } from 'date-fns'
import {
  Alert,
  Breadcrumb,
  Col,
  Row,
  Spinner,
} from 'react-bootstrap'
import { partition } from 'lodash-es'
import './styles.scss'
import BookingCard from './BookingCard'

const BookingsListing = ({
  noBookings = null,
  isAdmin = false,
  filterFunc = undefined,
  bookingId = undefined,
  bookingsOverride = undefined,
  activeActions = null,
}) => {
  const { bookings: allBookings, updateBooking, refreshBookings, bookingsLoaded } = useBookings(!bookingsOverride, filterFunc)
  const [error, setError] = useState('')
  let bookings

  // TODO: use container to provide bookings
  if (bookingsOverride) {
    bookings = bookingsOverride
  } else {
    bookings = allBookings
  }

  const [cancelledBookings, activeBookings] = partition(bookings, (b) => b.cancelled)
  const [pastBookings, futureBookings] = partition(activeBookings, (b) => !isFuture(parseISO(`${b.date} 23:59:59`)))

  const onUpdateBooking = (bookingId, payload) => {
    return updateBooking(bookingId, payload)
    .then((_response) => {
      //console.log('refreshing data')
      refreshBookings(bookingId)
    })
    .catch((err) => {
      console.log("Hello? Setting error to", err)
      setError(err)
    })
  }

  if (!bookings || !bookingsLoaded) {
    return (
      <Spinner animation="border" role="status" variant="primary" className="mb-2" />
    )
  }

  if (bookings.length === 0) {
    return noBookings()
  }

  const bookingCardProps = {}
  if (isAdmin) {
    bookingCardProps.titleFunc = (_confirmed, resident, title) => title ? title : `Unit ${resident.unit} Booking`
  }

  if (bookingId) {
    const booking = bookings.find((b) => b.id === bookingId)

    if (!booking) {
      return (
        <>
          <Row>
            <Col sm={12}>
              <Alert variant="danger">No booking found. It may have already been cancelled.</Alert>
            </Col>
          </Row>
        </>
      )
    }

    return (
      <>
        {error && (
          <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>
        )}
        <Row>
          <Col sm={12} md={6} lg={4}>
            <BookingCard
              booking={booking}
              isAdmin={isAdmin}
              isActive
              onUpdateBooking={onUpdateBooking}
              {...bookingCardProps}
            />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <h3>Active Bookings</h3>

      {error && (
        <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>
      )}

      <Row>
        {futureBookings.length == 0 && (
          <Col sm={12}>
            No active bookings.
          </Col>
        )}

        {futureBookings.map((booking) => (
          <Col sm={12} md={6} lg={4} key={booking.id}>
            <BookingCard
              booking={booking}
              isAdmin={isAdmin}
              isActive
              onUpdateBooking={onUpdateBooking}
              {...bookingCardProps}
            />
          </Col>
        ))}
      </Row>

      {activeActions && activeActions() }

      {pastBookings.length > 0 && (
        <>
          <h3 className="mt-3">Past Bookings</h3>

          <Row>
            {pastBookings.map((booking) => (
              <Col sm={12} md={6} lg={4} key={booking.id}>
                <BookingCard
                  booking={booking}
                  isAdmin={isAdmin}
                  {...bookingCardProps}
                />
              </Col>
            ))}
          </Row>
        </>
      )}

      {cancelledBookings.length > 0 && (
        <>
          <h3 className="mt-3">Cancelled Bookings</h3>

          <Row>
            {cancelledBookings.map((booking) => (
              <Col sm={12} md={6} lg={4} key={booking.id}>
                <BookingCard
                  booking={booking}
                  isAdmin={isAdmin}
                  {...bookingCardProps}
                />
              </Col>
            ))}
          </Row>
        </>
      )}
    </>
  )
}

export default BookingsListing
